import { put, takeEvery } from "redux-saga/effects";

//Actions
import * as ACTIONS from "./../actions/actionConstants";

//Auth
import { db } from "./../firebase";

function* handleClient(action) {
  const { filter } = action;
  if (filter === "toggle_user") {
    const { cUID, uUID, val } = action.payload;
    let value = val === false ? "inactive" : "active";

    //Update Client users
    yield db.doUpdateClientUserStatus(cUID, uUID, value);

    yield put({
      type: ACTIONS.SYNC,
      meta: {
        cUID,
        filter: "updateClient"
      }
    });

    yield put({
      type: ACTIONS.OPEN_SNACKBAR,
      payload: {
        variant: "info",
        message: `user status changed to ${value}`
      }
    });
  }

  if (filter === "delete_user") {
    const { cUID, uUID, val } = action.payload;
    console.log(uUID, cUID, val);
    if (val) {
      //Delete
      yield db.doUpdateClientUserStatus(cUID, uUID, "deleted");

      yield put({
        type: ACTIONS.SYNC,
        meta: {
          cUID,
          filter: "updateClient"
        }
      });

      //Display Snackbar
      yield put({
        type: ACTIONS.OPEN_SNACKBAR,
        payload: {
          variant: "success",
          message: `user deleted`
        }
      });
    } else {
      yield put({
        type: ACTIONS.OPEN_SNACKBAR,
        payload: {
          variant: "warning",
          message: `user NOT deleted`
        }
      });
    }
  }
}

export function* clientWatcher() {
  yield takeEvery(ACTIONS.HIT_CLIENT, handleClient);
}



// WEBPACK FOOTER //
// ./src/sagas/client.js